export default {
    blogCardsId: 'bundle-blogcards-'+Math.random().toString(36).substr(2, 16),
    blogUrl: 'https://yoursite.com/blog',
    blogCardsAmount: 6,
    showLinesOfText: 3,
    useFiltering: false,

    desktopAmountPerRow: 3,
    tabletAmountPerRow: 2,
    phoneAmountPerRow: 1,

    useCustomFont: false,
    customFontName: "'Helvetica Neue', sans-serif",
    customFontWeight: "400",
    customFontStyle: 'normal',

    fontFamily: 'Roboto',
    fontWeight: '400',
    fontStyle: 'normal',
    fontGoogleLoad: 'Roboto:400',

    cardTitleFontSize: 17,
    lineHeightTitle: 1.4,

    useCustomFontText: false,
    customFontNameText: "'Helvetica Neue', sans-serif",
    customFontWeightText: "400",
    customFontStyleText: 'normal',

    fontFamilyText: 'Roboto',
    fontWeightText: '400',
    fontStyleText: 'normal',
    fontGoogleLoadText: 'Roboto:400',

    cardTextFontSize: 14,
    lineHeightText: 1.6,

    cardBorderColor: '#ccc',
    cardBg: '#fff',
    readmoreBg: '#333',
    readmoreColor: '#fff',
    readmoreBgHover: '#1c8ff3',
    readmoreColorHover: '#fff',

    blogcardTextColor: '#555',
    blogcardTitleColor: '#222',

    filterItemBorderColor: '#555',
    filterItemColor: '#555',
    filterItemBg: '#fff',

    filterItemBorderColorHover: '#1c8ff3',
    filterItemColorHover: '#fff',
    filterItemBgHover: '#1c8ff3',
    filterAlignement: 'left',

    useCustomFontFilter: false,
    customFontNameFilter: "'Helvetica Neue', sans-serif",
    customFontWeightFilter: "400",
    customFontStyleFilter: 'normal',

    fontFamilyFilter: 'Roboto',
    fontWeightFilter: '400',
    fontStyleFilter: 'normal',
    fontGoogleLoadFilter: 'Roboto:400',

    cardFilterFontSize: 14,

    cardImageHeightDesktop: 150,
    cardImageHeightTablet: 150,
    cardImageHeightPhone: 150,

    useRoundedEdge: true

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/blogcardssettings.js